import {EntityApiService, ApiClientService} from '@dofleini/security';

class SocialReasonApiService extends EntityApiService {

    getOne = (reasonId) => ApiClientService.get(this.getPath(`/${reasonId}`));

}

export default new SocialReasonApiService('/ms-core/api/socialreasons');
